import { ElementRef } from '@angular/core';
import { Renderer } from '@angular/core';
import { StudiosService } from './../../../../services/studios';
import { Component, ViewChild } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { MapService } from '../../../../services/map';
import { FiltersService } from '../../../../services/filters';
import { SessionService } from '../../../../services/session';
import { LocationsService } from '../../../../services/locations';

@Component({
  selector: 'page-search-bar',
  templateUrl: 'search-bar.html',
})
export class SearchBarPage {
  @ViewChild('myInput') myInput;

  studioList = [];

  constructor(
    public viewCtrl: ViewController,
    public studiosService: StudiosService,
    public filtersService: FiltersService,
    public mapService: MapService,
    public renderer: Renderer,
    public elementRef: ElementRef,
    public sessionService: SessionService,
    public locationsService: LocationsService
  ) {}

  ionViewDidLoad() {
    this.onSearchInput();
  }

  onSearchInput() {
    if (this.mapService.searchText === '') {
      this.studioList = this.studiosService.studios.filter((studio) => this.inCityOrVirtual(studio));
      if (this.studioList.length === 0) {
        this.studioList = this.studiosService.studios;
      }
      return;
    }

    this.studioList = this.studiosService.studios.filter(
      (studio) => {
        const studioName = this.removeAccents(studio.name.toLowerCase());
        const searchStudioName = this.removeAccents(this.mapService.searchText.toLowerCase());

        return studioName.indexOf(searchStudioName, 0) > -1 && this.inCityOrVirtual(studio);
      }
    );
  }

  removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  inCityOrVirtual(studio) {
    return studio.virtual || this.filtersService.queryParams.city === studio.city.id;
  }

  selectStudio(studio) {
    this.viewCtrl.dismiss(studio);
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/find-class/search-bar/search-bar.ts